import _ from "lodash";

export function handleTabStrips($container) {
	if (typeof $container !== 'object') {
		$container = $($container)
	}

	initializeStrip($container, 'detail-tab-strip', 'top')
	initializeStrip($container, 'shops-tab-strip', 'left')
	initializeStrip($container, 'inner-tab-strip', 'top')

	var preselectTab = true;
	if (window.history.length  == 1) {
		preselectTab = false;
		if (window.performance.getEntriesByType("navigation")) {
			let type = window.performance.getEntriesByType("navigation")[0].type;
			if (type == 1 || type == 'reload') {
				preselectTab = true;
			}
		}
	}

	if (typeof (Storage) !== "undefined" && preselectTab) {
		var tabStripsSettings = getTabStripSettings()
		_.forEach(tabStripsSettings, function (object, key) {
			var $tabStrip = $('#' + key).data("kendoTabStrip");
			if (typeof $tabStrip !== 'undefined') {
				$tabStrip.select(object.activeTab)
			}
		})
	}
}

function getTabStripSettings() {
	var tabStripsSettings = localStorage.getItem('tabStrips')
	if (typeof tabStripsSettings === 'undefined' || tabStripsSettings === null) {
		return {}
	} else {
		return JSON.parse(tabStripsSettings)
	}
}

function initializeStrip($container, selector, tabPosition) {
	var $tabStrip = $container.find('[' + selector + ']')

	$tabStrip.kendoTabStrip({
		tabPosition: tabPosition,
		activate: function (e) {

			let $tabStripItem = $(e.item)
			var tabStripId = $tabStripItem.closest('[' + selector + ']').attr('id')
			var activeTabIndex = $tabStripItem.index()

			if ($tabStripItem.data('content')) {
				let $tabStripContentElement = $(e.contentElement)
				if (!$tabStripContentElement.data('loaded')) {
					$.get($tabStripItem.data('content'), function (data) {
						$tabStripContentElement.html(data)
						handleComponents($tabStripContentElement)
					})
					$tabStripContentElement.data('loaded', true)
				}
			}

			if (typeof (Storage) !== "undefined") {
				var tabStripsSettings = getTabStripSettings()

				tabStripsSettings[tabStripId] = {tabStrip: tabStripId, activeTab: activeTabIndex}

				localStorage.setItem('tabStrips', JSON.stringify(tabStripsSettings))
			}

		},
		animation: {
			open: {
				effects: ""
			}
		}
	})

}
